import React from 'react';
import { CardContentProps } from './types';
import { cn } from '../../../lib/utils';

export const CardContent: React.FC<CardContentProps> = ({
  className,
  children
}) => {
  return (
    <div className={cn("space-y-4", className)}>
      {children}
    </div>
  );
};